import type { Product as LiquidProduct } from '@grafikr/shopify-typescript/type/liquid/Product';
import { checkSellingPlans } from 'utils/check-selling-plans';
import clear from 'utils/clear';
import { NonNullish } from 'utils/nullish-check';

type SellingPlanGroup = {
  app_id: string;
  id: string;
  name: string;
  options: {
    name: string;
    position: number;
    values: string[];
  }[];
  selling_plans: {
    id: number;
    description: string;
    name: string;
    recurring_deliveries: boolean;
  }[];
}

type Product = {
  title: LiquidProduct["title"];
  url: string;
  id: LiquidProduct["id"];
  selling_plan_groups: SellingPlanGroup[];
}

function addVariantListener(node: HTMLElement) {
  const sellingPlanWrapper = NonNullish(node.querySelector<HTMLElement>('[data-component="selling-plan"]'));
  const select = node.querySelector<HTMLSelectElement>('select[name="id"]');

  if (select) {
    select.addEventListener('change', () => {
      [...sellingPlanWrapper.children].forEach(section => (section as HTMLElement).hidden = true);

      const activeSection = NonNullish(sellingPlanWrapper.querySelector<HTMLElement>(`[data-variant-id="${select.value}"]`));
      activeSection.hidden = false;

      const firstSellingPlan = activeSection.querySelector<HTMLElement>(`[data-selling-plan-group]:not([data-selling-plan-group="one-time"])`);

      if (firstSellingPlan) {
        firstSellingPlan.click();
      }
    });
  }
}

export async function updateQuickBuy(
  template: HTMLTemplateElement,
  callback: () => void
) {
  if (!template) {
    throw new Error('Missing quick buy template');
  }

  const drawer = NonNullish(
    document.querySelector<HTMLElement>('.drawer[data-component="quick-buy"]'),
    'Missing quick buy drawer'
  );
  const drawerContent = NonNullish(
    drawer.querySelector<HTMLElement>('[data-reactive]')
  );
  const drawerProductTitle = NonNullish(
    drawer.querySelector<HTMLElement>('[data-product-title]')
  );

  const data: Product = JSON.parse(
    NonNullish(template.content.querySelector('script')).innerHTML
  );

  clear(drawerContent);
  drawerContent.appendChild(template.content.cloneNode(true));
  drawerProductTitle.textContent = data.title;

  await checkSellingPlans(data, drawerContent);
  addVariantListener(drawerContent);

  if (callback) {
    callback();
  }
}

export default updateQuickBuy;
